export default {
  functional: true,

  props: {
    tag: { type: String, default: 'h1' },
  },

  render: (h, { data, props, children }) => {

    data.staticClass =  `blocked--heading ${data.staticClass || ''}`.trim()

    return h(props.tag, data, [h('span', children)])
  }
}
